<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true">添加</el-button>
    <el-dialog
      :visible="dialogVisible"
      title="录入TX"
      width="500px"
      @close="closeDialog"
    >
      <el-form :model="txDetail" ref="txForm" :rules="rules" label-width="100px">
        <el-form-item label="币种：" prop="type">
          <el-select v-model="txDetail.type" placeholder="请选择">
            <el-option
              v-for="item in coinTypes"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地址：" prop="hashCode">
          <el-input v-model="txDetail.hashCode"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import validAddress from 'common/validAddress';

export default {
  name: 'recordDetail',
  data() {
    const validAddressFunc = (rule, value, callback) => {
      const isValid = validAddress(value, this.txDetail.type);
      if (!isValid) callback(new Error(`不是有效的${this.txDetail.type}地址`));
      callback();
    };
    return {
      txDetail: {},
      dialogVisible: false,
      rules: {
        type: [{ required: true, message: '请选择币种！' }],
        hashCode: [
          { required: true, message: '请填写地址！' },
          {
            validator: validAddressFunc
          }
        ]
      }
    };
  },
  computed: {
    ...mapState('txRecord', ['coinTypes'])
  },
  methods: {
    ...mapActions('txRecord', ['getCoinTypes', 'createRecord']),
    closeDialog() {
      this.dialogVisible = false;
      this.txDetail = {};
      this.$refs['txForm'].resetFields();
    },
    handleSave() {
      this.$refs['txForm'].validate(valid => {
        if (valid) {
          this.createRecord(this.txDetail).then(() => {
            this.$message({
              message: '添加成功！',
              type: 'success'
            });
            this.dialogVisible = false;
            this.$emit('refresh', { page: 1 });
          });
        }
      });
    }
  },
  created() {
    this.getCoinTypes();
  }
};
</script>
